import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { DrawerState } from './types'
import { RootState } from '../../types'

export const state: DrawerState = {
  showNavigationDrawer: false,
  showSideDrawer: false,
  sideDrawerType: null
}

const namespaced = true

export const drawer: Module<DrawerState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
